import { useState, useEffect } from "react";
import Header from "../header";
import Footer from "../footer";
import MobileLayout from "../mobile_layout";
import DesktopLayout from "../desktop_layout";

const CaseStudy = ({ data }) => {
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <>
      <Layout>
        <Header color="rgba(11, 21, 76, 1)" />
      </Layout>
      <Layout backgroundColor="black">
        <div className="w-full mt-10 py-16 lg:py-10">
          <div className="w-[88%] lg:w-[80%] mx-auto flex flex-col items-center">
            <div className="w-[100%] min-h-[400px] mb-10">
              <img src={data.image} alt=""></img>
            </div>
            {/* Header Section */}
            <div className="mb-12 lg:mb-7">
              <h2 className="text-[32px] lg:text-[40px] xl:text-[50px] text-white RoobertLight leading-[120%] mb-4">
                {data.title}
              </h2>
            </div>
            {/* Body Text */}
            <div className="mb-12 lg:mb-8 space-y-5">
              <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                Business Problem:
              </h3>
              <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                {data.businessProblem}
              </p>
              <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                Approach:
              </h3>
              <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                {data.approach}
              </p>
              <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                Solution Highlights:
              </h3>
              <ul className="list-disc pl-5 space-y-2 text-white text-[16px] lg:text-[18px] leading-[140%]">
                {data.solutionHighlights.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                Impact:
              </h3>
              <ul className="list-disc pl-5 space-y-2 text-white text-[16px] lg:text-[18px] leading-[140%]">
                {data.impact.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              {data.conclusion && (
                <>
                  <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                    Conclusion:
                  </h3>{" "}
                  <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                    {data.conclusion}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default CaseStudy;
